import { Controller, useFormContext } from 'react-hook-form'

import { CheckBoxGroup, FF2, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

const FilingTypeRenderer = (field: any) => {
  const { setValue, clearErrors } = useFormContext<SarEdit>()

  const userSelectCheckbox = (c: string, v: string[]) => v.includes(c) && !field.value.includes(c)

  const deselectCheckbox = (c: string, v: string[]) => {
    const i = v.indexOf(c)
    if (i !== -1) {
      v.splice(i, 1)
    }
  }

  const handleChange = (v: string[]) => {
    const newValue = [...v]

    if (userSelectCheckbox('filingTypeInitial', newValue)) {
      deselectCheckbox('filingTypeCorrectAmend', newValue)
      deselectCheckbox('filingTypeContinuing', newValue)

      clearErrors('generalInfo.priorReportBsaId')
      setValue('generalInfo.priorReportBsaId', '')
    }

    if (
      userSelectCheckbox('filingTypeCorrectAmend', newValue) ||
      userSelectCheckbox('filingTypeContinuing', newValue)
    ) {
      deselectCheckbox('filingTypeInitial', newValue)
    }

    field.onChange(newValue)
  }

  return (
    <FF2
      label="1. Type of filing"
      field={field}
      input={(props) => (
        <CheckBoxGroup
          {...props}
          data-qa={'1. Type of filing'}
          direction="horizontal"
          data={[
            { label: 'Initial report', value: 'filingTypeInitial' },
            { label: 'Correct/amend prior report', value: 'filingTypeCorrectAmend' },
            { label: 'Continuing activity report', value: 'filingTypeContinuing' },
            { label: 'Joint report', value: 'filingTypeJoint' }
          ]}
          onChange={handleChange}
        />
      )}
    />
  )
}

export const FilingType = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="generalInfo.filingType"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) => FilingTypeRenderer(field)}
    />
  )
}
